import { identify } from './analytics';
import { apiJson } from './api';

export type Wallet = {
  plan_name: string;
  plan_code: string;
  plan_tokens: number;
  package_tokens: number;
  total: number;
  next_refill_at: string;
  next_refill_tokens: number;
};

export type Me = {
  id: number;
  email: string;
  preferred_language: string;
  wallet: Wallet | null;
};

export async function fetchMe(): Promise<Me> {
  const me = await apiJson<Me>('/api/me/');
  // Analytics identify is idempotent — safe to call on every page fetch.
  if (me.email) identify(me.id, me.email);
  return me;
}

export async function updateMe(payload: { preferred_language?: string }): Promise<Me> {
  return apiJson<Me>('/api/me/', {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}
